// extracted by mini-css-extract-plugin
export default {"input":"CustomerFilter_input__6753U"};